import { render, staticRenderFns } from "./gocco-term-suggestion.vue?vue&type=template&id=ecb18e8a&"
import script from "./gocco-term-suggestion.vue?vue&type=script&lang=ts&"
export * from "./gocco-term-suggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports